import apiHelpers from './apiHelpers';

// name (lowercased) -> imageUrl | null. Hovering the same card twice, or the
// same card in two different replies, must not refetch.
const cache = new Map();
// name (lowercased) -> in-flight promise, so hovering quickly doesn't fire two
// requests for one card.
const pending = new Map();

/**
 * Resolves a card name to its Scryfall image URL, via our own card endpoint.
 *
 * Going through our API rather than straight to Scryfall is deliberate: the
 * stored `imageUrl` is already a Scryfall CDN link (cards.scryfall.io), which is
 * what they ask clients to use for images instead of hitting their API on every
 * request — and the endpoint creates the card from Scryfall when we don't have
 * it yet, so unknown cards still resolve.
 */
export function getCardImageUrl(name) {
  const key = (name || '').trim().toLowerCase();
  if (!key) return Promise.resolve(null);
  if (cache.has(key)) return Promise.resolve(cache.get(key));
  if (pending.has(key)) return pending.get(key);

  const request = apiHelpers
    .getCardByName(name.trim())
    .then(response => {
      const card = response.data && response.data[0];
      const imageUrl = card && card.imageUrl ? card.imageUrl : null;
      cache.set(key, imageUrl);
      pending.delete(key);
      return imageUrl;
    })
    .catch(() => {
      // Cache the miss too: a name Scryfall doesn't know shouldn't be retried on
      // every hover.
      cache.set(key, null);
      pending.delete(key);
      return null;
    });

  pending.set(key, request);
  return request;
}

const cardImages = { getCardImageUrl };

export default cardImages;
